import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import HistoryThumbnailCard from '~/components/Card/HistoryThumbnailCard';
import HistoryCard from '~/components/Card/HistoryCard';
import config from '~/config';

const Header = styled.h3`
  font-weight: 500;
  font-size: 20px;
  @media (max-width: 700px) {
    font-size: 18px;
  }
`;

const ScrollContainer = styled.div`
  margin-top: 0px;
  margin-left: -5px;
  margin-right: -5px;
  position: relative;
  @media (max-width: 700px) {
    margin-left: -16px;
    margin-right: -16px;
  }
`;

const ScrollPadding = styled.div`
  @media (min-width: 701px) {
    overflow: hidden;  
  }
  @media (max-width: 700px) {
    position: relative;
  }
`;

const Scroll = styled.div`
  white-space: nowrap !important;
  overflow-x: visible;
  @media (max-width: 700px) {
    overflow-x: auto;
    overflow-y: hidden;
    transform: translateX(0) !important;
    -webkit-overflow-scrolling: touch;
  }
  transition: transform .4s;
`;

const Gradient = styled.div`
  position: absolute;
  top: 0;
  width: 20px;
  height: 100%;
  pointer-events: none;
  @media (min-width: 601px) {
    display: none !important;
  }
`;

const GradientLeft = styled(Gradient)`
  left: 0;
  background: linear-gradient(to left, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 100%);
`;

const GradientRight = styled(Gradient)`
  right: 0;
  background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 100%);
`;

const animation = keyframes`
  0% {
    background-position: 50% 50%;
  }
  28% {
    background-position: 120% 50%;
  }
  100% {
    background-position: 50% 50%;
  }
`;

const Arrow = styled.div`
  display: block;
  width: 30px;
  height: 80px;
  box-sizing: border-box;
  position: absolute;
  top: 12%;
  bottom: 0;
  background-image: url('${config.assetPath}/static/icons/chevron-right-grey.png');
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 20px;
  cursor: pointer;
  &:hover {
    animation: ${animation} 0.95s infinite;
  }
  @media(max-width: 600px) {
    display: none !important;
  }
`;

const LeftArrow = styled(Arrow)`
  right: initial;
  left: -25px;
  transform: rotate(180deg);
`;

const RightArrow = styled(Arrow)`
  right: -25px;
`;

export default class HistorySection extends Component {
  static propTypes = {
    name: PropTypes.string,
    fullPath: PropTypes.string,
    objects: PropTypes.array,
  };

  static defaultProps = {
    name: 'Just Viewed',
    objects: [],
  };

  state = {
    current: 0,
    activeIndex: -1,
  };

  constructor(props) {
    super(props);
    this.goLeft = this.goLeft.bind(this);
    this.goRight = this.goRight.bind(this);
    this.close = this.close.bind(this);
    // const { objects } = props;
  }

  onClickThumbailCard = (index) => {
    this.setState(state => ({ activeIndex: index === state.activeIndex ? -1 : index }));
  }

  goRight = () => {
    this.setState(state => ({ current: state.current + 1 }));
  }

  goLeft = () => {
    this.setState(state => ({ current: state.current - 1 }));
  }

  close = () => {
    this.setState({ activeIndex: -1 });
  }
  // state = {
  //   isOpen: false,
  // }
  // openMoal = () => {
  //   this.setState({isOpen: true});
  // }
  // closeModal = () => {
  //   this.setState({isOpen: false});
  // }

  render() {
    const { name, objects, fullPath, sessionData, rates } = this.props;
    const { current, activeIndex } = this.state;
    const display = 6;
    // const x = (type === 'trip' ? -50 : -33.33) * current;
    // const x = -16.66 * current;
    const x = -16.66 * current;
    return (
      <div>
        <Header>
          <span>{name}</span>
        </Header>
        <ScrollContainer>
          <ScrollPadding>
            <Scroll style={{ transform: `translateX(${x}%)` }}>
              {objects.map((obj, index) => (
                <HistoryThumbnailCard
                  key={`history-${index}`}
                  data={obj}
                  active={activeIndex === index}
                  fog={activeIndex === -1}
                  onClick={() => this.onClickThumbailCard(index)}
                />
              ))}
            </Scroll>
            <GradientLeft />
            <GradientRight />
          </ScrollPadding>
          {current > 0 && <LeftArrow onClick={this.goLeft} />}
          {(current + display) < objects.length && <RightArrow onClick={this.goRight} />}
        </ScrollContainer>
        <div>
          {activeIndex >= 0 && objects && (objects.length > activeIndex) && (
            <div key={`data-${activeIndex}`}>
              <HistoryCard data={objects[activeIndex]} onClose={this.close} fullPath={fullPath} sessionData={sessionData} rates={rates} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
